import React from 'react';
import { Link } from 'gatsby';
import '../../styles/scss/style.scss';

export const Hero4 = () => {
  return (
    <div className="animated bounce feature feature-2" style={{ marginTop:"10rem" }}>
      <div className="feature__wrap">
        <div className="feature__left">
          <img
            src={require('../../components/images/looppredesign.png')}
            alt="loop design ui kit"
            className="feature__img"
          />
        </div>
        <div className="feature__right">
          <h2 className="feature__lead feature__lead--1 showcase__lead">
            Predesigned landing pages, templates and sections
          </h2>
          <p className="feature__text">
            Loop Pro X also comes with predesigned layouts, landing pages and sections that can help you get started faster on your designs. 
            This can also be customized easily with the different variants available in loop
           </p>
          <br />
          
          <Link to="https://www.figma.com/proto/VgccgKbbxDwXrqMSTJS842/Loop-Pro-X?node-id=201%3A32&viewport=297%2C200%2C0.02586517482995987&scaling=scale-down"
          target="_blank" className="btn1">
            Preview Pages
          </Link>
        </div>
      </div>
    </div>
  );
};
